import milestone from '@/api/project-mgt/project-milestone'
import attachment from '@/api/project-mgt/module-attchment'

import { baseState, baseMutations } from '@/store/mixins'

export const state = {
  ...baseState,
  pagination_task: {
    currentPage: 1,
    lastPage: 1,
    perPage: 15,
    total: 6,
    from: 1,
    to: 15
  }
}

export const getters = {}

export const mutations = {
  ...baseMutations,
  SET_PAGINATION_TASK(state, value) {
    state.pagination_task = value
  }
}

export const actions = {
  fetch(context, attrubutes = {}) {
    let params = Object.assign(
      {
        page: context.state.pagination.page,
        perPage: context.state.pagination.perPage,
        filter: {
          search: context.state.search
        }
      },
      attrubutes
    )
    return milestone.get({ params }).then(response => {
      context.commit('RECEIVE_RESOURCES', response)
      return Promise.resolve(response)
    })
  },
  store(context, data) {
    return milestone.store(data)
  },
  update(context, { id, data }) {
    return milestone.update(id, data)
  },
  destroy(context, id) {
    return milestone.destroy(id)
  },
  find(context, id) {
    return milestone.find(id)
  },
  formViewModel(context, attrubutes = {}) {
    return milestone.formViewModel({ params: attrubutes })
  },
  getTask(context, params) {
    return milestone.getTask({ params })
  },
  history(context, params) {
    return milestone.history({ params })
  },
  attachFile(context, data) {
    return attachment.store(data)
  },
  deleteAttachment(context, id) {
    return attachment.destroy(id)
  }
}
